import React, { useEffect, useState } from 'react';
import { PeriodosAdapter } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorTiposContenido from './selector';

export const SelectorTiposContenidoContainer = (props: any) => {
  
	let {año, periodo} = props;
	const api = new PeriodosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [periodos, setPeriodos] = useState<any>([])
	let result: any;
  
  useEffect(()=>{
	getTiposContenido(año, periodo);
  },[año, periodo])

	const getTiposContenido = async (año: number, periodo: number) => {
		try {
			if(año != undefined && periodo != undefined){
				result = await api.ListarTiposContenido(año, periodo);
				if(result.data && result.data!=="")
				{
					setPeriodos([ ...result.data ] || []);
				}else{resultError()}
			}else{setPeriodos([])}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorTiposContenido {...props} data={periodos}/>
};

export default SelectorTiposContenidoContainer;